export default __webpack_public_path__ + "static/media/eb-pro-wht-poster-1.807834f3.jpg";